import { styled } from '@mui/material/styles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';

export const DatagridStyled = styled(DatagridWithStickyActions)({
  '& .column-name': { width: 0 },
  '& .column-alias': { width: 0 },
  '& .column-active': { width: 0, textAlign: 'center' },
  '& .column-securityIssues': { width: 0 },
  '& .column-commissions': { width: 0 },
  '& .column-white_ip_addresses': { width: 0 },
  '& .column-comment': { minWidth: '280px' },
});
